import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m24.444 22.169-.1.076-2.819 2.45-3.767.942a1 1 0 0 0 .37 1.962l.115-.021 3.767-.942a2 2 0 0 0 .679-.314l.148-.117 2.82-2.45a1 1 0 0 0-1.213-1.586m-8.87-15.994-.165.066-4.123 1.866H9.238L6.326 6.653a2 2 0 0 0-2.586.722l-.081.14-3.074 5.888a2 2 0 0 0 .723 2.628l.155.086 2.909 1.453 1.82 2.126.045.058.056.06 4.6 4.6a2 2 0 0 0 1.728.561l.17-.035 7.246-1.81c.217-.055.423-.145.61-.268l.136-.097 6.758-5.283 2.996-1.498a2 2 0 0 0 .954-2.554l-.076-.161-3.074-5.887a2 2 0 0 0-2.52-.93l-.147.067-2.797 1.397-6.084-1.773a2 2 0 0 0-1.218.032m.66 1.888 6.09 1.776 3.405 6.52-6.178 4.83L12.307 23 8.533 19.23l3.96-2.88 1.007.759a5 5 0 0 0 5.807.137l.193-.137.678-.509a2 2 0 0 0 .33-2.886l-.116-.128L15.5 8.693a2 2 0 0 0-.228-.196zm-6.627 2.044h4.479L18.978 15l-.678.509a3 3 0 0 1-3.428.12l-.172-.12-1.6-1.2a1 1 0 0 0-1.078-.079l-.11.07-4.752 3.456-.96-1.123zM5.432 8.442l2.211 1.106-3.074 5.887-2.211-1.105zm21.136-.134 3.075 5.888-2.21 1.105-3.075-5.887z"
    />
  </svg>
);
const SvgIconHandshake = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHandshake);
export default Memo;
